import styled from 'styled-components'
import Box from 'components/shared/Box'

export const InvoiceSection = styled(Box)`
    max-width: 594px;
`

export const AddressRow = styled(Box)`
    width: 100%;
`
